export const TOGGLE_RIGHT_DOCK = 'TOGGLE_RIGHT_DOCK';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const TOGGLE_EDITOR_DOCKED = 'TOGGLE_EDITOR_DOCKED';
export const TOGGLE_GALLERY_DOCKED = 'TOGGLE_GALLERY_DOCKED';
export const SET_DOCK_WIDTH = 'SET_DOCK_WIDTH';

export function toggleRightDock(visible) {
  return {
    type: TOGGLE_RIGHT_DOCK,
    data: visible
  };
}

export function setActiveTab(tab) {
  return {
    type: SET_ACTIVE_TAB,
    data: tab
  };
}

export function toggleEditorDocked(docked) {
  return {
    type: TOGGLE_EDITOR_DOCKED,
    data: docked
  };
}

export function toggleGalleryDocked(docked) {
  return {
    type: TOGGLE_GALLERY_DOCKED,
    data: docked
  };
}

export function setDockWidth(width) {
  return {
    type: SET_DOCK_WIDTH,
    data: width
  };
}

